import { useState } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

/**
 * Long text in a table cell: truncated to one line by default, the full text
 * shows on hover, and clicking toggles the cell open so it can be read in
 * place without opening the edit form.
 */
const ExpandableText = ({ text, maxWidth = 400, className = '' }) => {
  const [expanded, setExpanded] = useState(false);
  if (!text) return <>&mdash;</>;

  const toggle = e => {
    e.stopPropagation();
    setExpanded(v => !v);
  };

  const paragraph = (
    <p
      className={`mb-0 ${expanded ? '' : 'text-truncate'} ${className}`}
      style={{
        maxWidth,
        fontSize: '1rem',
        cursor: 'pointer',
        whiteSpace: expanded ? 'pre-wrap' : undefined
      }}
      onClick={toggle}
      title={expanded ? 'Click to collapse' : undefined}
    >
      {text}
    </p>
  );

  if (expanded) return paragraph;

  return (
    <OverlayTrigger
      placement="top"
      popperConfig={{ strategy: 'fixed' }}
      overlay={
        <Tooltip style={{ maxWidth: 420 }}>
          <div className="text-start" style={{ whiteSpace: 'pre-wrap' }}>
            {text}
          </div>
          <div className="fs--2 text-400 mt-1">Click to expand</div>
        </Tooltip>
      }
    >
      {paragraph}
    </OverlayTrigger>
  );
};

ExpandableText.propTypes = {
  text: PropTypes.string,
  maxWidth: PropTypes.number,
  className: PropTypes.string
};

export default ExpandableText;
